import * as React from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';
import {
  Block,
  StatusMessage,
} from '@hvcgroep/design-system';
import NibudIcon from '../../components/NibudIcon';
import { NibudData } from '../../types/orchestrator';
import Button from '../../../../shared/components/Button';
import { heatApi } from '../../store/slices/HeatApi';

function findClosestNibudType(sjvGJ: number, nibudData: NibudData[]) {
  let closestObj = nibudData[0];
  let closestDiff = Math.abs(sjvGJ - Number(nibudData[0].Value.split(',')[0]));

  for (let i = 1; i < nibudData.length; i++) {
    const diff = Math.abs(sjvGJ - Number(nibudData[i].Value.split(',')[0]));
    if (diff < closestDiff) {
      closestDiff = diff;
      closestObj = nibudData[i];
    }
  }

  return closestObj;
}

type Props = {
  sjvGJ: string;
  className: string,
  onOpenEstimateExplanation: () => void;
};

const HouseTypeBlock: React.FC<Props> = (props) => {
  const {
    sjvGJ, className, onOpenEstimateExplanation,
  } = props;
  const { t } = useTranslation();

  const { data, status } = heatApi.endpoints.getNibudData.useQuery(null);
  const [trigger] = heatApi.endpoints.getNibudData.useLazyQuerySubscription();

  if (status === 'rejected' || !data || data.length === 0) {
    return (
      <StatusMessage type="error">
        <p className="mb-4">{t('registration_desk.server_errors.get_nibud')}</p>
        <Button
          variation="center"
          onClick={() => trigger(null)}
        >
          {t('registration_desk.buttons.retry')}
        </Button>
      </StatusMessage>
    );
  }

  const closest = findClosestNibudType(Number(sjvGJ), data);
  const classnames = c('HouseTypeBlock', 'd-flex', 'align-items-start', 'faq-item__inner-component', className);

  return (
    <Block className={classnames}>
      <NibudIcon nibudType={closest.Price_Index_Name} className="mr-3" />
      <div>
        <p className="mb-0">
          {t('registration_desk.house_type_block.body', {
            sjv: sjvGJ,
            house_type: t(`registration_desk.nibud_title.${closest.Price_Index_Name}`),
          })}{' '}
          <button onClick={onOpenEstimateExplanation} type="button" className="a no-styling">
            {t('registration_desk.house_type_block.link')}
          </button>
        </p>
      </div>
    </Block>
  );
};

export default HouseTypeBlock;
